import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

const Seo = ({ pageTitle, pageDescription, pageStructuredData }) => {
  const query = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          description
          siteUrl
          title
        }
      }
    }
  `)

  const siteMetadata = query.site.siteMetadata
  const metaDescription =
    pageDescription === undefined ? siteMetadata.description : pageDescription
  const metaTitle = `${siteMetadata.title} | ${pageTitle}`
  const metaImage = `${siteMetadata.siteUrl}/legacy-home-protect-logo.png`

  return (
    <div className='application'>
      <Helmet>
        <html lang='en-GB'></html>
        <title>{metaTitle}</title>
        <meta charSet='utf-8' />
        <meta name='description' content={metaDescription} />
        <meta name='author' content={siteMetadata.title} />
        <meta name='robots' content='index,follow' />
        <meta name='language' content='en-GB' />
        <meta name='copyright' content={siteMetadata.title} />
        <meta name='Classification' content='Business' />
        <meta name='reply-to' content='info@legacyhp.co.uk' />

        {/* OpenGraph */}
        <meta property='og:title' content={siteMetadata.title} />
        <meta property='og:type' content='website' />
        <meta name='og:url' property={siteMetadata.siteUrl} />
        <meta property='og:image' content={metaImage} />
        <meta property='og:site_name' content={siteMetadata.title} />
        <meta property='og:description' content={metaDescription} />
        <meta property='og:email' content='info@legacyhp.co.uk' />
        <meta property='og:phone_number' content='03454503359' />
        <meta property='og:latitude' content='52.632701' />
        <meta property='og:longitude' content='-1.1287618' />
        <meta
          property='og:street-address'
          content='6 St Georges House, St Georges Way'
        />
        <meta property='og:locality' content='Leicester' />
        <meta property='og:region' content='England' />
        <meta property='og:postal-code' content='LE1 1SH' />
        <meta property='og:country-name' content='United Kingdom' />

        {/* OpenGraph Twitter */}
        <meta name='twitter:card' content='summary_large_image' />
        <meta property='twitter:domain' content={siteMetadata.siteUrl} />
        <meta property='twitter:url' content={siteMetadata.siteUrl} />
        <meta name='twitter:title' content={metaTitle} />
        <meta name='twitter:description' content={metaDescription} />
        <meta name='twitter:image' content={siteMetadata.siteUrl} />
      </Helmet>
    </div>
  )
}

export default Seo
